const users = {
  users: 'Users',
  first_name: 'First Name',
  last_name: 'Last Name',
  login: 'Login',
  edit_user: 'User',
  user_details: 'User Details',
  add_user: 'New User',
  add_new_user_modal_title: 'Add new user',
  user_created_successfully: 'User created successfully',
  could_not_create_user: 'Could not create user',
  search_user: 'Search User',
  display_events: 'Display events',
  select_at_least_one_user_to_view_events:
    'Select at least one user to view events',
  max_selection_reached: 'You can only select up to {{ count }} users',
  delete_user_message:
    'Are you sure you want to delete {{user}}? <br> If the user has associated credentials, these will also be unassigned.',
  delete_morethan_one_site:
    'NOTE: This user is associated with more than one site, it will be deleted from all of them.',
  confirm_modal_confirm: 'Yes, delete',
  remove_login: 'Remove Login',
  remove_confirmation_msg:
    'Are you sure you want to remove the user web access?',
  activate_confirm_msg:
    'Are you sure you want to {{action}} {{user}} on {{account}} account?',
  access_levels: 'Access levels',
  no_custom_fields: 'There are no custom fields configured for this site.',
  general_information: 'General Information',
  custom_fields: 'Custom Fields',
  custom_fields_success: 'Custom fields saved successfully',
  custom_field_type_single_line_string: 'Text field',
  custom_field_type_numeric: 'Numeric',
  custom_field_type_date: 'Date',
  custom_field_type_email: 'Email',
  custom_field_type_checkbox: 'Checkbox',
  custom_field_type_true_or_false: 'True or false',
  unassign_site_credentials_note:
    'Unassigning the user from this site will unassign any associated credentials.',
  unassign_site_last_site_note:
    'It will also delete the user from this account.',
  access_rights: 'Access Rights',
  table: {
    first_name: 'FIRST NAME',
    last_name: 'LAST NAME',
    email: 'EMAIL',
    user: 'USER',
    role: 'ROLE',
    phone: 'PHONE',
    last_login: 'LAST LOGIN',
    status: 'STATUS',
  },
  form: {
    username: 'Username',
    email: 'Email',
    phone_number: 'Phone Number',
    date_created: 'Date Created',
    date_updated: 'Date Updated',
    new_password: 'New Password',
    role: 'Role',
    select_role: 'Select Role',
    no_role: 'No role',
    define_email:
      'Define an email address for this user before giving them a role.',
    set_as_admin: 'Set as {{role}}',
  },
  profile: {
    actions: 'Actions',
    role_details: 'Role Details',
    company_organization: 'Company/Organization',
    remove_from_company_confirm:
      'Are you sure you want to remove {{name}} from {{company}}? Important: this action is not reversible.',
    change_role_confirm:
      'Are you sure you want to change {{name}} role from {{prevRole}} to {{currentRole}}? Important: this action is not reversible.',
    roles_table_aria_label: 'User roles and companies table',
    location: 'Locations',
    device: 'Device',
    ip_address: 'IP Address',
    date_time: 'Date/Time',
    profile: 'Profile Details',
    update: 'Update',
    activities: 'Activities',
    change: 'Change',
    user_updated: 'User Profile has been updated',
    user_updated_success: 'User successfully updated',
    could_not_update_user: 'Could not update user',
    profile_deleted: 'User profile deleted',
    could_not_delete_profile: 'Could not delete user profile',
    role_updated: 'Role updated',
    could_not_update_role: 'Could not update role',
    allowed_filetypes: 'Allowed file types: png, jpg, jpeg.',
    avatar_modal_description: 'Are you sure you want to remove your avatar?',
    login_sessions: 'Login Sessions',
  },
  add: {
    country: 'Country',
    city: 'City',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    assign_card: 'Assign credential',
    none: 'None',
    first_registration: 'First registration',
    coming_from_another_site: 'Coming from another site',
    user_found: 'User found!',
    no_user_found:
      'No user was found associated to this crendential, please use another card.',
    use_this_user: 'Use this user',
    no_reader: 'No reader',
  },
  security: {
    allow_extend_time: 'Allow Extend Time',
    allow_antipassback_override: 'Allow Anti-passback Override',
    activation_date: 'Activation Date',
    expiration_date: 'Expiration Date',
    generate_keypad_code: 'Generate a new keypad code',
    all: 'All',
  },
  card: {
    assign_a_card: 'Assign a credential',
    assign: 'Assign',
    to: 'to',
    format: 'Format',
    card_number: 'Credential number',
    assign_card_confirm:
      'Do you want to assign Credential {{number}} to {{username}}?',
    confirm_btn: 'Confirm',
    display_name: 'Display name',
  },
  delete: {
    success: 'The user {{name}} has been deleted successfully',
    error: 'Could not delete',
  },
  error: {
    invalid_email: 'Invalid email format',
    invalid_date: 'Invalid date format',
  },
  events: {
    tabTitle: 'Events',
  },
};

export default users;
